export default __webpack_public_path__ + "static/media/pni.31cf3090.png";